import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "consent"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasSelectTarget || !this.hasConsentTarget) return

    const visible = ["on_faculty", "Na fakultě"].includes(this.selectTarget.value)
    this.consentTarget.hidden = !visible
    this.consentTarget.querySelectorAll("input").forEach((input) => {
      input.disabled = !visible
    })
  }
}
